import type * as Immutable from 'immutable';
import { createMigration } from './utils';

/**
 * Drops the zoom a media that is not cover filled never drew.
 *
 * Until now a media's zoom (`transformMatrix` scale) was applied only to cover filled media; a
 * contain or area filled media ignored it, though one could still be stored on it. Zoom now applies
 * to every fill mode, so each media whose fill mode is not cover gets a scale of 1 and is drawn
 * exactly as it was. Its pan (`transformMatrix` translation) already applied to every fill mode and
 * is left alone, as is every cover filled media, the default when no fill mode is stored.
 */

const MEDIA_CLASS_TYPES = ['MediaAsset', 'TimeAwareMediaAsset'];
const SCALE_X_INDEX = 0;
const SCALE_Y_INDEX = 3;

function migrateAssets(map: Immutable.Map<string, unknown>, listPath: Array<string | number>) {
    const assets = map.getIn(listPath) as
        | Immutable.List<Immutable.Map<string, unknown>>
        | undefined;
    assets?.forEach((asset, index) => {
        const assetPath = [...listPath, index];
        if (asset.get('children')) {
            migrateAssets(map, [...assetPath, 'children']);
        }
        if (!MEDIA_CLASS_TYPES.includes(asset.get('classType') as string)) {
            return;
        }
        const fillMode = (asset.get('fillMode') as string | undefined) || 'cover';
        const matrix = asset.get('transformMatrix') as Immutable.List<number> | undefined;
        if (fillMode === 'cover' || !matrix) {
            return;
        }
        map.setIn([...assetPath, 'transformMatrix', SCALE_X_INDEX], 1);
        map.setIn([...assetPath, 'transformMatrix', SCALE_Y_INDEX], 1);
    });
}

export const migrationTo9_247 = createMigration({
    migrateVideo(video) {
        return video.withMutations((map) => {
            map.get('slides').forEach((_scene: unknown, i: number) => {
                map.setIn(
                    ['slides', i],
                    this.migrateScene(map.getIn(['slides', i]) as Immutable.Map<string, unknown>),
                );
            });
        });
    },
    migrateScene(scene) {
        return scene.withMutations((map) => {
            migrateAssets(map, ['children']);
            migrateAssets(map, ['stickers']);
            const subslides = map.get('subslides') as Immutable.List<unknown> | undefined;
            subslides?.forEach((_subslide, index) => {
                migrateAssets(map, ['subslides', index, 'children']);
            });
        });
    },
});
